import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";
import { upsertTransportFee } from "../thunks/upsertTransportFee";
import { setFetchState } from "../transportFeesDataReducer";
import { TransportFee } from "../types";

export const useTransportFeeUpsert = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (store) => store.data.clearing.transportfees.fetchState
  );

  const dispatch = useDispatch();
  const dispatchUpsertTransportFee = React.useCallback(
    (stfee: TransportFee) => dispatch(upsertTransportFee(stfee)),
    [dispatch]
  );

  React.useEffect(() => {
    dispatch(setFetchState({ type: "not-started" }));
  }, [dispatch]);

  return [fetchState, dispatchUpsertTransportFee] as [
    typeof fetchState,
    typeof dispatchUpsertTransportFee
  ];
};
